var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"divider-margin"},[_c('b-col',{staticClass:"text-center"},[_c('b-img',{attrs:{"fluid":"","src":"https://res.cloudinary.com/oredev/image/upload/v1742856561/2025/Info/divider_green.svg","alt":"","aria-hidden":"true"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7614f338","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dividers/DividerGreen.vue
// module id = JYpZ
// module chunks = 1